// extracted by mini-css-extract-plugin
module.exports = {"carouselWrap":"carouselWrap___2XSdv","page":"page___37fXP","current":"current___LSXFr","total":"total___1KXo1"};